$(function () {
    var param = getUrlParameter("contact_posted");

/*     if(getCookie("messaggioInviato")) {
        disableMoreInfo();
    } else if(param === 'true') {
        $(".snippet-snackbar").addClass("mostra");
        setCookie('messaggioInviato', "true")
        disableMoreInfo();
    } */
    

    $(".hero-action.links-wrap").on("click", function () {
        $(".hero-list-product").toggleClass("hero-action-wrp");
        $(".hero-list-product > div").toggleClass("hero-action-container");

    })


    $(".bottone-teaser").on("click", function () {
        showVideo();
    });
    
    
    $(".chiudi-video").on("click", function () {
        closeVideo();
    });

    $(".button-more-info").on("click", function (evt) {
        toggleLayer();
        hideAcerillFormLogo();
    })

    $(".button-watch-live").on("click", function (evt) {
        showVideo();
    })
    
    $(".icona-chiudi-video").on("click", function (evt) {
        closeVideo();
    })
    
    $(".button-close-layer").on("click", function (evt) {
        toggleLayer();
    })
})

function toggleLayer () {
    $(".primo-layer").toggleClass("hidden");
    $(".secondo-layer").toggleClass("hidden");
}

function hideAcerillFormLogo() {
    const elems = document.querySelectorAll('.ace-cf-panel-body form + div')
    if(elems) { elems.forEach(elem => elem.parentNode.removeChild(elem)); }
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

function disableMoreInfo () {
    $(".button-more-info").toggleClass("hidden");
}

function setCookie(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/";
}

function getCookie(name) {
    let cookieName = name + "=";
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) == 0) {
        return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}

function showVideo () {
    $(window).scrollTop(0);
    $(".wrp-header").addClass("hidden");
    $("body").css("overflow", "hidden");
    
    if($( window ).width() < $( window ).height() ) {
        $(".live-modal-mobile-preview").removeClass("hidden")
        setTimeout(() => {
            $(".live-modal-mobile-preview").addClass("hidden")
            $(".live-modal").removeClass("hidden");
        }, 2000);
    } else {
        $(".live-modal").removeClass("hidden");
    }
    playVideo()
}

function closeVideo () {
    $(".live-modal").addClass("hidden");
    $(".wrp-header").removeClass("hidden");
    $("body").css("overflow", "auto");
    pauseVideo()
}

function playVideo() {
    var player = document.querySelector("iframe");
    player.contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
}

function pauseVideo() {
    var player = document.querySelector("iframe");
    player.contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
}